<template>
  <div class="flex animate-pulse flex-col">
    <div
      class="flex aspect-posterMobile animate-pulse flex-col bg-secondary px-4 pb-8 md:aspect-posterDesktop md:rounded-2xl md:px-9 md:pb-6"
    />
  </div>
</template>
